import { render, staticRenderFns } from "./oldChangeDetail.vue?vue&type=template&id=24e7be45&scoped=true"
import script from "./oldChangeDetail.vue?vue&type=script&lang=js"
export * from "./oldChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./oldChangeDetail.vue?vue&type=style&index=0&id=24e7be45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7be45",
  null
  
)

export default component.exports